import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

// Solid icons (fas) — import only the ones actually used
import {
  faPhone,
  faChevronRight,
  faChevronDown,
  faRightFromBracket,
  faBars,
  faStore,
  faEnvelope,
  faHome,
  faNewspaper,
  faScaleBalanced,
  faSearch,
  faShoppingBag,
  faStar,
  faThLarge,
} from '@fortawesome/free-solid-svg-icons';

// Regular icons (far) — only the ones actually used
import { faStar as faStarRegular } from '@fortawesome/free-regular-svg-icons';

// Add only the used icons to the library
library.add(
  faPhone,
  faChevronRight,
  faChevronDown,
  faRightFromBracket,
  faBars,
  faStore,
  faEnvelope,
  faHome,
  faNewspaper,
  faScaleBalanced,
  faSearch,
  faShoppingBag,
  faStar,
  faThLarge,
  faStarRegular,
);

export { FontAwesomeIcon };
